export default function (needle, rule) {
  return (
    (typeof rule === "string" && (rule.split(":")[0] ?? null) === needle) ||
    (Array.isArray(rule) &&
      rule.map((i) => i.split(":")[0] ?? null).includes(needle))
  );
}
